<template>
    <modal name="ssamtalk-step-modal" class="category-update-modal ssamtalk-step-modal"
           :width="'80%'"
           :height="'auto'"
           @before-close="handlerBeforeClose"
           @before-open="handlerBeforeOpen"
           @opened="handlerOpened"
    >
        <div class="list-content pa15">
            <div class="modal_title">step 영역 {{listCount+1}}</div>
            <div class="pl30 pr30 pb15">
                <ssam-talk-step-write-component :ssamTalkType="ssamTalkType" :ssamTalkKey="ssamTalkKey" :ssamTalkStepKey="ssamTalkStepKey" :viewAfterFunc="afterFunc"></ssam-talk-step-write-component>
                <div class="btn_wrap text-center mt20" v-if="isEdit">
                    <el-button type="save" @click="save">저장</el-button>
                    <el-button type="cancel" @click="close()">닫기</el-button>
                    <el-button type="danger" class="del_btn float_right" @click="runDelete()" v-if="ssamTalkStepKey != 0">삭제</el-button>
                </div>
            </div>
        </div>
    </modal>
</template>

<script>
import util from "@/mixins/util";
import EventBus from "@/utils/event-bus";
import alertMixins from "@/mixins/alertMixins";
import SsamTalkStepWriteComponent from "@/components/ssamtalk/SsamTalkStepWriteComponent.vue";

export default {
    name: "SsamTalkStepModal",
    mixins: [alertMixins],
    components: {
        SsamTalkStepWriteComponent,
    },
    props: {
        categoryType: ''
    },
    data() {
        return {
            ssamTalkType: 'stepCreate',
            ssamTalkKey: 0,
            ssamTalkStepKey: 0,
            listCount: 0,
            isEdit: true,
        }
    },
    beforeRouterEnter() {
    },
    created() {
    },
    mounted() {
    },
    beforeDestroy() {
    },
    destroyed() {
    },
    computed: {},
    methods: {
        handlerBeforeOpen(event) {
            if (util.isEmpty(event.params) || util.isEmpty(event.params.ssamTalkKey)) { // 등록시
                event.stop();
                return;
            }
            this.ssamTalkKey = event.params.ssamTalkKey;
            if (!util.isEmpty(event.params) && !util.isEmpty(event.params.ssamTalkStepKey)) { // 등록시
                this.ssamTalkStepKey = event.params.ssamTalkStepKey;
                this.ssamTalkType = 'stepUpdate';
            }else {
                this.ssamTalkStepKey = 0;
                this.ssamTalkType = 'stepCreate';
            }
            if (!util.isEmpty(event.params) && !util.isEmpty(event.params.listCount)) { // 등록시
                this.listCount = event.params.listCount;
            }else {
                this.listCount = 0;
            }
            if (!util.isEmpty(event.params) && !util.isEmpty(event.params.isEdit)) { // 등록시
                this.isEdit = event.params.isEdit;
            }else {
                this.isEdit = true;
            }
        },
        handlerOpened() {
        },
        handlerBeforeClose() {
            this.ssamTalkKey = 0;
            this.ssamTalkStepKey = 0;
            this.ssamTalkType = 'stepCreate';
            this.isEdit = true;
        },
        close() {
            this.$modal.hide('ssamtalk-step-modal');
        },
        afterFunc() {
            EventBus.$emit('getList')
        },
        save() {
            EventBus.$emit('writeSsamTalkStep')
        },
        runDelete() {
            EventBus.$emit('deleteSsamTalkStep');
        },
    },
    watch: {},
}
</script>

<style scoped>

</style>
